import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@upme/ui/components/tooltip';
import { cn } from '@upme/ui/lib/utils';
import type { LucideIcon } from 'lucide-react';

type Props = {
  icon: LucideIcon;
  label: string;
  value: string;
  muted?: boolean;
  className?: string;
};

/** Компактная метрика на карточке CRM: outline-иконка + значение. */
export function CrmMetricChip({ icon: Icon, label, value, muted, className }: Props) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              'inline-flex items-center gap-1 text-sm tabular-nums leading-none',
              muted ? 'text-muted-foreground/70' : 'text-muted-foreground',
              className,
            )}
          >
            <Icon className="size-[18px] shrink-0 stroke-[1.5]" aria-hidden />
            <span className="sr-only">{label}</span>
            <span aria-hidden>{value}</span>
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-xs">
          {label}: {value}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
